import axios from '../js/ajax'

/** 获取聊天列表 */
export const getMessageList = (params) => axios.get('/chat/getMessageList', {params})
/** 获取聊天信息 */
export const getChatMessageList = (params) => axios.get('/chat/getChatMessageList', {params})
/** 发送消息 */
export const sendChatMessage = (params) => axios.postJson('/chat/sendChatMessage', params)
/** 获取房间详情 */
export const getChatSessionDetails = (params) => axios.get('/chat/getChatSessionDetails', {params})
/** 修改房间详情 */
export const modifyChatSessionDetails = (params) => axios.get('/chat/modifyChatSessionDetails', {params})
/** 退出聊天 */
export const signOutChatRoom = (params) => axios.postJson('/chat/signOutChatRoom', params)
/** 获取切换用户的标志 */
export const getLoginUserChatRoom = (params) => axios.get('/chat/getLoginUserChatRoom', {params})
/** 查看全部成员 */
export const getUserEntityAndBusinessEntity = (params) => axios.get('/chat/getUserEntityAndBusinessEntity', {params})
/** 创建聊天 */
export const createChatRoom = (params) => axios.postJson('/chat/createChatRoom', params)
/** 查询房间所有成员 */
export const getChatRoomMember = (params) => axios.get('/chat/getChatRoomMember', {params})
/** 添加成员 */
export const addChatMember = (params) => axios.postJson('/chat/addChatMember', params)
/** 查询历史消息 */
export const getHistoryChatMessageList = (params) => axios.get('/chat/getHistoryChatMessageList', {params})
/** 查询最新消息 */
export const getNewestChatMessageList = (params) => axios.get('/chat/getNewestChatMessageList', {params})
/** 清空消息 */
export const clearChatMessage = (params) => axios.post('/chat/clearChatMessage', params)
/** 增加cookie */
export const addSessionCookie = (params) => axios.get('/callback/addSessionCookie', {params})
/** 检测cookie */
export const checkSession = (params) => axios.get('/qrCode/checkSession', {params})





